import { render, staticRenderFns } from "./VariantSifterViewportControls.vue?vue&type=template&id=5867cf94&scoped=true&"
import script from "./VariantSifterViewportControls.vue?vue&type=script&lang=js&"
export * from "./VariantSifterViewportControls.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterViewportControls.vue?vue&type=style&index=0&id=5867cf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867cf94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5867cf94')) {
      api.createRecord('5867cf94', component.options)
    } else {
      api.reload('5867cf94', component.options)
    }
    module.hot.accept("./VariantSifterViewportControls.vue?vue&type=template&id=5867cf94&scoped=true&", function () {
      api.rerender('5867cf94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterViewportControls.vue"
export default component.exports